// extracted by mini-css-extract-plugin
export var csatScore = "_js-5";
export var header = "_js-1";
export var panelWrapper = "_js-2";
export var postPreview = "_js-3";
export var rightContent = "_js-0";
export var wrappingText = "_js-4";